import { DELETE_ACCOUNT_MANAGER_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[DELETE_ACCOUNT_MANAGER_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'Delete Account Manager',
	},
}
